__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "apmt-flow-shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@maersk-global/apmt-dpos-common", "1.0.0", () => (Promise.all([__webpack_require__.e(264), __webpack_require__.e(733), __webpack_require__.e(449), __webpack_require__.e(29), __webpack_require__.e(488), __webpack_require__.e(47), __webpack_require__.e(948), __webpack_require__.e(216), __webpack_require__.e(905), __webpack_require__.e(637)]).then(() => (() => (__webpack_require__(3216))))));
			register("@maersk-global/apmt-flow-keycloak", "1.0.0", () => (Promise.all([__webpack_require__.e(733), __webpack_require__.e(139), __webpack_require__.e(488), __webpack_require__.e(269)]).then(() => (() => (__webpack_require__(4452))))));
			register("@maersk-global/apmt-react-icons", "1.0.0", () => (Promise.all([__webpack_require__.e(488), __webpack_require__.e(961), __webpack_require__.e(85)]).then(() => (() => (__webpack_require__(7961))))));
			register("@maersk-global/apmt-react-layout", "1.0.0", () => (Promise.all([__webpack_require__.e(264), __webpack_require__.e(488), __webpack_require__.e(948), __webpack_require__.e(838)]).then(() => (() => (__webpack_require__(838))))));
			register("@tanstack/react-query", "4.29.14", () => (Promise.all([__webpack_require__.e(555), __webpack_require__.e(488)]).then(() => (() => (__webpack_require__(6555))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(144), __webpack_require__.e(488)]).then(() => (() => (__webpack_require__(3144))))));
			register("react-router-dom", "6.30.1", () => (Promise.all([__webpack_require__.e(955), __webpack_require__.e(488), __webpack_require__.e(47)]).then(() => (() => (__webpack_require__(8955))))));
			register("react", "18.2.0", () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(4041))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};